import { useEffect, useState } from "react";
import BoatTypeGraphic from "./BoatTypeGraphic";
import { getBoat, mediaUrl } from "../lib/api";

/** Cart imagery resolved LIVE from the asset, never from a url stored in the
 *  cart. Picture ids are derived server-side and can change between deploys, so
 *  a url captured at add-to-cart time later 404s -- which is exactly how a cart
 *  line rendered raw alt text on a broken image. If the live lookup fails, or the
 *  image itself fails to load, we fall back to the type illustration so a broken
 *  image can never show as text. */
export const CartLineImage = ({ line, locationId }) => {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    setFailed(false);
    setSrc(null);
    if (!line?.assetId) return undefined;
    getBoat(line.assetId, locationId, line.date)
      .then((b) => {
        if (!alive) return;
        const url = b?.listing?.heroImageUrl || b?.heroImageUrl || null;
        setSrc(url ? mediaUrl(url) : null);
      })
      .catch(() => alive && setSrc(null));
    return () => {
      alive = false;
    };
  }, [line?.assetId, line?.date, locationId]);

  if (!src || failed) {
    return (
      <div data-testid={`cart-line-image-fallback-${line.id}`}>
        <BoatTypeGraphic typeName={line.assetTypeName} />
      </div>
    );
  }
  return (
    <img
      src={src}
      data-testid={`cart-line-image-${line.id}`}
      alt={`${line.displayName}, ${line.assetTypeName || "boat"}`}
      loading="lazy"
      width={352}
      height={198}
      className="w-full object-cover"
      style={{ aspectRatio: "16 / 9" }}
      onError={() => setFailed(true)}
    />
  );
};

export default CartLineImage;
